import React from 'react'

function SectionHeader({ children }) {
  return <div className="mb-4 md:mb-6">{children}</div>
}

export default SectionHeader
